import React from 'react';
import './GenericPopup.scss';

const GenericPopup = ({ 
  isVisible, 
  type = "error",
  heading,
  message, 
  onOk, 
  okButtonText = "OK",
  showSecondButton = false,
  secondButtonText = "",
  onSecondButton = null
}) => {
  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return "https://d1flzashw70bti.cloudfront.net/original/images/operatorDashBoard/check_1790160650017.svg";
      case 'error':
      default:
        return "https://d1flzashw70bti.cloudfront.net/original/images/operatorDashBoard/error_1790160650017.svg";
    }
  };

  return (
    <div className="generic-popup-overlay">
      <div className={`generic-popup generic-popup--${type}`}>
        <div className="generic-popup-icon">
          <img 
            src={getIcon()} 
            alt={type} 
            className="generic-popup-svg"
          />
        </div>
        {heading && (
          <div className="generic-popup-heading">
            {heading}
          </div>
        )}
        <div className="generic-popup-message">
          {message}
        </div>
        <div className={`generic-popup-actions ${showSecondButton ? 'dual-buttons' : ''}`}>
          <button 
            className="generic-popup-btn"
            onClick={onOk}
          >
            {okButtonText}
          </button>
          {showSecondButton && (
            <button 
              className="generic-popup-btn generic-popup-btn--secondary"
              onClick={onSecondButton}
            >
              {secondButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GenericPopup;
